<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon">
    <mat-icon class="mdi-24px" fontIcon="mdi-account" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <mat-form-field style="width: 200px; margin-left: 20px;">
    <input matInput [formControl]="filterControl" placeholder="Search" (click)="applyFilter('')" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="button-end">
    <mat-paginator #paginator [length]="teamTypeList?.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]" (page)="paginatorEvent($event)"></mat-paginator>
  </div>
</div>

<div class="table-container mat-elevation-z2">
  <table mat-table [dataSource]="displayedTeamTypes" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions-header">
        <button mat-icon-button (click)="addOrEditTeamType(null)" title="Add TeamType" [disabled]="!canEdit">
          <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="addOrEditTeamType(row); $event.stopPropagation()"
          title="Edit Team Type" [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline"></mat-icon>
        </button>
        <button mat-icon-button (click)="deleteTeamTypeRequest(row); $event.stopPropagation()"
          title="Delete Team Type" [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>TeamType</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="isOfficialScoreContributor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
        title="When enabled, teams of this type will contribute to the official evaluation score">
        Is Official Score Contributor
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [checked]="row.isOfficialScoreContributor" [disabled]="!canEdit"
          (change)="toggleIsOfficialScoreContributor(row)" (click)="$event.stopPropagation()">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="showTeamTypeAverage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header
        title="When enabled, the average score for this team type will be displayed">
        Show TeamType Average
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [checked]="row.showTeamTypeAverage" [disabled]="!canEdit"
          (change)="toggleShowTeamTypeAverage(row)" (click)="$event.stopPropagation()">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
